import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  LeaveRequestService,
  ProcessLeaveRequestPayload,
} from "../../../../../services/vos/leave-request/leave-request.service";
import { IVosResponse } from "../../../../../services/vosClient";

const useProcessLeaveRequest = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<IVosResponse<unknown>, unknown, ProcessLeaveRequestPayload>({
    mutationFn: (payload: ProcessLeaveRequestPayload) => LeaveRequestService.processLeaveRequest(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["AFL-requests"],
        type: "all",
      });
    },
  });

  return mutation;
};

export default useProcessLeaveRequest;
